var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighlightMouseCursor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "highlight_mouse_cursor"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21205_61961",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21205_61961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "highlight_mouse_cursor (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2896 5.34252C18.7987 4.26498 21.468 3.72729 24.2927 3.72729C29.8485 3.72729 34.5864 5.62803 38.4764 9.42579C42.3617 13.2189 44.446 17.8741 44.7226 23.366C44.7595 24.0023 44.5676 24.5657 44.127 25.0063C43.7154 25.4179 43.2066 25.6605 42.6207 25.7338L42.6036 25.7359L42.5864 25.7368C41.9143 25.7742 41.3196 25.5637 40.8402 25.1034C40.3719 24.6538 40.1186 24.0859 40.0803 23.4286C39.6982 19.0065 38.0994 15.4198 35.3 12.635C32.5132 9.86261 28.8604 8.46146 24.2927 8.46146C19.8952 8.46146 16.1685 9.9992 13.0837 13.084C9.99897 16.1687 8.46123 19.8954 8.46123 24.2928C8.46123 28.6085 9.89237 32.2313 12.7524 35.193C15.617 38.1593 19.165 39.7726 23.4236 40.0352L23.4359 40.0359L23.4481 40.0373C24.0993 40.1096 24.6557 40.3781 25.088 40.848C25.5274 41.3256 25.7259 41.9129 25.6924 42.5727C25.6891 43.21 25.4547 43.7585 24.9818 44.1723C24.5232 44.5735 23.9752 44.7596 23.3664 44.7227C20.607 44.5995 18.032 43.9854 15.6464 42.8772C13.268 41.7725 11.1925 40.3049 9.42379 38.4747C7.65438 36.6438 6.2633 34.5138 5.25036 32.0889C4.23378 29.6552 3.72705 27.0549 3.72705 24.2928C3.72705 21.4682 4.26474 18.7989 5.34228 16.2898C6.41617 13.7892 7.88357 11.6061 9.74471 9.74493C11.6059 7.8838 13.7889 6.4164 16.2896 5.34252Z",
    fill: "#FFF9EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "highlight_mouse_cursor_2",
    d: "M37.6883 41.4274L31.6678 35.4289L30.1564 40.0088C30.02 40.3882 29.7606 40.5703 29.3784 40.5551C28.9958 40.5398 28.7515 40.3425 28.6455 39.963L24.2557 25.2417C24.1802 24.9609 24.254 24.7084 24.4773 24.4844C24.7009 24.2606 24.9528 24.1829 25.233 24.2513L39.933 28.6617C40.3043 28.768 40.4976 29.0128 40.5128 29.3962C40.528 29.7793 40.35 30.0392 39.9787 30.176L35.3979 31.6907L41.4289 37.7244C41.961 38.2577 42.2271 38.8748 42.2271 39.5756C42.2271 40.2765 41.961 40.8938 41.4289 41.4274C40.8964 41.9607 40.2729 42.2273 39.5584 42.2273C38.8438 42.2273 38.2204 41.9607 37.6883 41.4274Z",
    fill: "#FCBE1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightMouseCursor);
export default __webpack_public_path__ + "static/media/highlightMouseCursor.5cf5df6d839a46d97bb5dd2d6e6571f4.svg";
export { ForwardRef as ReactComponent };